import React, { forwardRef, useImperativeHandle, useState } from "react";
import MediaQuery from "react-responsive";

export default forwardRef(({ text, background }, ref) => {
    useImperativeHandle(ref, () => ({
        getOriginalAmount: () => {
            return originalAmount;
        },
        setOriginalAmount: (amount) => {
            setAmount(amount);
            setOriginalAmount(amount);
        },
        setAmount: (amount) => {
            setAmount(amount);
        },
    }));

    const [amount, setAmount] = useState(0);
    const [originalAmount, setOriginalAmount] = useState(0);

    return (
        <MediaQuery maxWidth="599px">
            {(isMobile) => {
                return (
                    <div
                        style={{
                            width: "160px",
                            marginLeft: isMobile ? "10px" : "25px",
                            marginRight: isMobile ? "10px" : "25px",
                            marginTop: "20px",
                            height: "75px",
                            textAlign: "center",
                            background,
                            borderRadius: "20px"
                        }}
                    >
                        <h4 style={{ color: "black", fontWeight: "bold" }}>{text}</h4>
                        <h4 style={{ color: "white", marginTop: 0 }}>{amount}₪</h4>
                    </div>
                );
            }}
        </MediaQuery>
    );
});
